<template>
  <v-row dense>
    <v-col xs="12" sm="12" md="12" lg="12">
      <v-row dense>
        <v-col xs="12" sm="12" md="12" lg="12">
          <v-card color="primary" class="ma-2">
            <v-data-table
              :headers="headers"
              :items="items"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Uploaded Files</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:no-data>No data</template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <tasks-table-stats
                    :stats="item.statistics"
                    :status="item.status"
                  />
                </td>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatDateWithTime(item.start) }}
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon color="primary" @click="openFile(item)">
                  mdi-file-link-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { DateTimeFormatter } from '../../shared/DateTime.formatter';

import { filesApiV1 } from '@/api/v1';
import { filesApiV2 } from '@/api/v2';

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        align: 'start',
        sortable: true,
        value: 'id'
      },
      { text: 'File name', value: 'name' },
      { text: 'User E-mail', value: 'user.email' },
      { text: 'Created', value: 'created_at' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    items: []
  }),
  created() {
    return this.getList();
  },
  methods: {
    formatDateWithTime(date) {
      return DateTimeFormatter.formatWithTime(date);
    },
    openFile(file) {
      window.open(file.location, '_blank');
    },
    onCreate() {
      this.getList();
    },
    getList() {
      (this.$store.getters.isMatcherApiV2Enabled ? filesApiV2 : filesApiV1)
        .getFiles({
          type: 'uploads'
        })
        .then((res) => {
          this.items = res.items;
        });
    }
  }
};
</script>

<style lang="scss"></style>
